import * as React from 'react';
import { Dispatch } from 'redux';
import { SessionViewModel } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as SessionNormalizers from '../normalizers/sessionNormalizers';

export class RefreshTokenRequest extends BaseApiPostRequest<
  SessionViewModel,
  EntityNormalizers.NormalizedEntityArray<SessionNormalizers.NormalizesSessions>
> {
  constructor(userId: string, refreshToken: string, component: React.Component, dispatch: Dispatch) {
    super({ refreshToken }, component, dispatch);
    this.path = `/sessions/${userId}/refresh`;
    this.normalizeMethod = SessionNormalizers.normalizeSession;
  }

  protected addAuthentication() {
    // Do nothing - unauthenticated request
  }
}
